import styled from 'styled-components'
import { Modal, Typography } from 'antd'
import { mediaMax } from '@/app/styles/breakpoints'
import { Icon } from '@/shared/ui/Icon/Icon'

const { Text } = Typography

export const ReconfigModal = styled(Modal)`
  && {
    @media (max-width: 767px) {
      max-width: calc(100vw - 32px);
    }

    ${mediaMax.sm} {
      position: fixed;
      min-width: 100vw;
      min-height: 100vh;
      height: 100vh;
      top: 0;
      left: 0;
      margin: 0;
      display: flex !important;
      flex-direction: column;
      & > div {
        display: flex;
        flex-direction: column;
        height: 100vh;
      }
    }

    .ant-modal-header {
      margin-bottom: 16px;
    }

    .ant-modal-content {
      padding: 20px 16px;
      border-radius: 6px;
      box-shadow: none;
      ${mediaMax.sm} {
        flex: 1;
        padding: 0;
        overflow: auto;
      }
    }

    .ant-modal-header {
      ${mediaMax.sm} {
        height: 88px;
        border-radius: 0;
        margin-bottom: 0;
        box-shadow: 0px 4px 16px 0px rgba(12, 16, 24, 0.12);
        display: flex;
        align-items: center;
        padding: 0 16px 0 64px;
      }
    }

    .ant-modal-close {
      top: 16px;
      inset-inline-end: 16px;
      ${mediaMax.sm} {
        top: 28px;
        left: 16px;
        right: auto;
      }
    }
  }
`

export const ConfirmModal = styled(Modal)`
  .ant-modal-content {
    padding: 14px 16px;
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.alert.warning.bg};
    border: 1px solid ${(props) => props.theme.colors.alert.warning.border};
    box-shadow: 8px 16px 48px 0px rgba(174, 174, 174, 1);
  }
`

export const ConfirmDesc = styled(Text)`
  font-size: 12px;
`

export const ConfirmIcon = styled(Icon)`
  flex: 0 0 auto;
`
